/* eslint-disable react-hooks/exhaustive-deps */
// import { useState } from "react";
// import { useForm } from "react-hook-form";
// import Input from "../../../components/Input";
// import { useUpdatePassword } from "../../../apis/settingsApis";
// import toast from "react-hot-toast";
// import { IconDeviceFloppy, IconEdit } from "@tabler/icons-react";

// type FormValues = {
//   currentPassword: string;
//   newPassword: string;
//   confirmPassword: string;
// };

// export default function Password() {
//   const [isEdit, setIsEdit] = useState(false);
//   const { mutate } = useUpdatePassword();
//   const {
//     register,
//     handleSubmit,
//     reset,
//     formState: { errors },
//   } = useForm<FormValues>();

//   const handleUpdatePassword = (data: any) => {
//     console.log("okay", data);

//     mutate(
//       { ...data },
//       {
//         onSuccess: () => {
//           reset();

//           setIsEdit(!isEdit);
//         },
//         onError: (error) => {
//           console.log(error, "error");
//           toast.error(`${error}`);
//         },
//       }
//     );
//   };

//   return (
//     <div className="divide-y divide-[#212121]/10  overflow-hidden">
//       <Input
//         name="currentPassword"
//         type="password"
//         title="Current Password"
//         placeholder=" "
//         register={register}
//         error={errors.currentPassword}
//         validation={{ required: "Current Password is required" }}
//         inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//           isEdit
//             ? "bg-white border border-[#D8D8D8]"
//             : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//         }`}
//         labelClass="w-[50%]"
//         className="flex justify-between items-center py-4"
//         disabled={!isEdit}
//       />
//       <Input
//         name="newPassword"
//         type="password"
//         title="New Password"
//         placeholder=" "
//         register={register}
//         error={errors.newPassword}
//         validation={{ required: "New Password is required" }}
//         inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//           isEdit
//             ? "bg-white border border-[#D8D8D8]"
//             : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//         }`}
//         labelClass="w-[50%]"
//         className="flex justify-between items-center py-4"
//         disabled={!isEdit}
//       />
//       <Input
//         name="confirmPassword"
//         type="password"
//         title="Confirm Password"
//         placeholder=" "
//         register={register}
//         error={errors.confirmPassword}
//         validation={{ required: "Confirm Password is required" }}
//         inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//           isEdit
//             ? "bg-white border border-[#D8D8D8]"
//             : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//         }`}
//         labelClass="w-[50%]"
//         className="flex justify-between items-center py-4"
//         disabled={!isEdit}
//       />
//       <div className="py-3">
//         <p className="text-sm  px-2 text-[#212121]  border-l-4 border-[#FBD037]">
//           <b>Note</b> : 8 characters minimum: One number: One uppercase
//           character: One lowercase character
//         </p>
//       </div>
//       <button
//         onClick={() =>
//           isEdit ? handleSubmit(handleUpdatePassword)() : setIsEdit(!isEdit)
//         }
//         className="bg-[#FBD037] text-[#212121] text-base font-semibold  p-2.5 rounded-full"
//       >
//         {isEdit ? <IconDeviceFloppy /> : <IconEdit />}
//       </button>
//     </div>
//   );
// }

import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Input from "../../../components/Input";
import { useUpdatePassword } from "../../../apis/settingsApis";
import toast from "react-hot-toast";
import { IconDeviceFloppy, IconEdit, IconLoader2 } from "@tabler/icons-react";
import { useLanguage } from "../../../context/LanguageContext";

type FormValues = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export default function Password() {
  const { t } = useLanguage();
  const [isEdit, setIsEdit] = useState(false);
  const { mutate, isPending } = useUpdatePassword();

  // Example: data fetched from API (replace with your API call)
  const fetchedData = {
    currentPassword: "", // <-- never comes from API in real-world
    newPassword: "",
    confirmPassword: "",
  };

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: fetchedData, // prefill when form mounts
  });

  const handleUpdatePassword = (data: FormValues) => {
    mutate(data, {
      onSuccess: () => {
        toast.success(t("Password updated successfully!"));
        setIsEdit(false);
        reset(data); // keep last entered values prefilled
      },
      onError: (error: any) => {
        console.error(error);
        toast.error(error?.message ? t(error.message) : t("Failed to update password"));
      },
    });
  };

  const newPassword = watch("newPassword");

  useEffect(() => {
    if (isEdit) {
      // prefill with fetched data whenever edit mode is enabled
      reset(fetchedData);
    }
  }, [isEdit, reset]);

  return (
    <div className="divide-y divide-[#212121]/10 overflow-hidden">
      {/* Current Password */}
      <Input
        name="currentPassword"
        type="password"
        title="Current Password"
        placeholder=" "
        register={register}
        error={errors.currentPassword}
        validation={{ required: t("Current Password is required") }}
        inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
          isEdit
            ? "bg-white border border-[#D8D8D8]"
            : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
        }`}
        labelClass="w-[50%]"
        className="flex justify-between items-center py-4"
        disabled={!isEdit}
      />

      {/* New Password */}
      <Input
        name="newPassword"
        type="password"
        title="New Password"
        placeholder=" "
        register={register}
        error={errors.newPassword}
        validation={{
          required: t("New Password is required"),
          minLength: {
            value: 8,
            message: t("Password must be at least 8 characters"),
          },
          validate: {
            hasUppercase: (v) =>
              /[A-Z]/.test(v) || t("Must contain at least one uppercase letter"),
            hasLowercase: (v) =>
              /[a-z]/.test(v) || t("Must contain at least one lowercase letter"),
            hasNumber: (v) =>
              /[0-9]/.test(v) || t("Must contain at least one number"),
          },
        }}
        inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
          isEdit
            ? "bg-white border border-[#D8D8D8]"
            : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
        }`}
        labelClass="w-[50%]"
        className="flex justify-between items-center py-4"
        disabled={!isEdit}
      />

      {/* Confirm Password */}
      <Input
        name="confirmPassword"
        type="password"
        title="Confirm Password"
        placeholder=" "
        register={register}
        error={errors.confirmPassword}
        validation={{
          required: t("Confirm Password is required"),
          validate: (value) =>
            value === newPassword || t("Passwords do not match"),
        }}
        inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
          isEdit
            ? "bg-white border border-[#D8D8D8]"
            : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
        }`}
        labelClass="w-[50%]"
        className="flex justify-between items-center py-4"
        disabled={!isEdit}
      />

      {/* Note */}
      <div className="py-3">
        <p className="text-sm px-2 text-[#212121] border-l-4 border-[#FBD037]">
          <b>{t("Note")}</b>: {t("Minimum 8 characters, must include one number, one uppercase, and one lowercase character.")}
        </p>
      </div>

      {/* Save / Edit Button */}
      <button
        onClick={() =>
          isEdit ? handleSubmit(handleUpdatePassword)() : setIsEdit(true)
        }
        disabled={isPending}
        className="bg-[#FBD037] text-[#212121] text-base font-semibold p-2.5 rounded-full flex items-center justify-center"
      >
        {isPending ? (
          <IconLoader2 className="animate-spin" />
        ) : isEdit ? (
          <IconDeviceFloppy />
        ) : (
          <IconEdit />
        )}
      </button>
    </div>
  );
}
